<article>
    <p class="why-stuff">
        All reports are for historical purposes only. Current reports can be found on the Connect Portal.
    </p>
    <button mat-flat-button color="primary" (click)="closeModal()">Close Message</button>
</article>